module.exports = __webpack_public_path__ + "static/img/sm10.d0522d7.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/sm10.png
// module id = nKXN
// module chunks = 1